import CartService from "@/services/Cart.js"

const state = {
    cart: null,
    shippingAddressExists: false,
    shippingAddressChanged: false,
    voucherCheckinId: null,
    invoice: null,
    campaign: localStorage.getItem('campaign') || '',
}


const getters = {
    containsDigitalItems: state => state.cart && state.cart.digital_items && state.cart.digital_items.length > 0,

    getDigitalItems: state => state.cart ? state.cart.digital_items : [],

    getCampaignCode: state => state.campaign && JSON.parse(state.campaign).campaign_code,
    getCampaigExpDate: state => state.campaign && JSON.parse(state.campaign).campaign_expires_at,
    campaignIsValid: (state, getters) => {
        if (getters.getCampaignCode) {
            const today = new Date()
            const campaignExpireDate = new Date(getters.getCampaigExpDate)
            return campaignExpireDate >= today
        } else {
            return false
        }

    },
    invoice: state => state.invoice
}


const mutations = {
    SET_CART(state, cart) {
        state.cart = cart
        state.shippingAddressExists = !!state.cart.shipping_address_first_name
    },

    SET_VOUCHER_CHECKIN_ID(state, id) {
        state.voucherCheckinId = id
    },

    SET_CAMPAIGN(state, campaign) {
        state.campaign = campaign
    },
    DELETE_CAMPAIGN() {
        state.campaign = ''
    },

    SET_INVOICE(state, invoice) {
        state.invoice = invoice
    },
    CLEAR_INVOICE(state) {
        state.invoice = null
    }
}


const actions = {
    getCart(context, params) {
        return CartService.getCart(params)
            .then(response => {
                context.commit('SET_CART', response.data)
                return response
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    emitFbPixelPurchaseEvent({state}, {currency, amount}) {
        // Track Facebook Pixel "Purchase" event
        // NOTE: we retrieve "num_items" from the cart to avoid include them into the API response
        // https://developers.facebook.com/docs/facebook-pixel/reference
        if (typeof fbq === 'function') {
            // eslint-disable-next-line
            fbq('track', 'Purchase', {
                currency: currency,
                value: amount,
               // num_items: state.cart.digital_items.length + state.cart.print_items.length
            })
        }

    },

    placeOrder({state, dispatch, getters}, payload) {
        let campaignCode = getters.getCampaignCode
        if (campaignCode) {
            if (!getters.campaignIsValid) {
                campaignCode = null
                dispatch('deleteCampaign')
            }
        }

        return CartService.placeOrder(payload.paymentMethod, payload.paymentMethodId, payload.billingAddress, campaignCode, state.invoice)
            .then(response => {
                return response
            })
    },

    deleteCampaign({commit}) {
        commit('DELETE_CAMPAIGN')
        localStorage.removeItem('campaign')
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
